import { useOrder } from '../../../../../state/order/hooks/useOrder';

// Pricing-api does not charge the shop's service fee on top of a phone order fee
export const useShownServiceFee = (serviceFee?: number | null): number => {
  const { hasPhoneOrderFee } = useOrder();

  if (hasPhoneOrderFee || !serviceFee || serviceFee < 0) return 0;

  return serviceFee;
};
